import React from 'react';

const RemovedBanner = () => (
  <div className="banner banner__red">
    content has been removed
  </div>
);

export default RemovedBanner;


// WEBPACK FOOTER //
// ./src/components/utilities/RemovedBanner.js